/** offset for new task nodes being placed beneath a selected node */
export const NEW_TASK_NODE_Y_OFFSET = 125;

/** offset added to new node so they don't overlap an existing node */
export const NEW_NODE_OVERLAP_OFFSET = 20;

/** tolerance to decide if node origins really overlap (to avoid floating-point imprecision) */
export const NEW_NODE_OVERLAP_TOLERANCE = 0.0001;
